var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "messageBox",
      staticClass: "document-box mt-3 border-top-0 border-bottom",
    },
    [
      _vm._l(_vm.comments.byId, function (comment) {
        return _c(
          "b-row",
          { key: comment.id, staticClass: "justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { cols: "11" } },
              [
                _c(
                  "b-row",
                  { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "b-col",
                      { staticClass: "my-auto", attrs: { cols: "3", sm: "1" } },
                      [
                        _c(
                          "profile-avatar",
                          _vm._b(
                            {
                              staticClass: "img-fluid rounded-circle sm",
                              attrs: { "avatar-options": { inline: false } },
                            },
                            "profile-avatar",
                            Object.assign({}, comment),
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "my-auto", attrs: { cols: "9", md: "4" } },
                      [
                        _c("p", { staticClass: "text-dark-gray bold mb-0" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("fullName")(comment)) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        comment.createdAt
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "text-dark-gray mb-0 text-uppercase small date",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("formatTimeAgo")(comment.createdAt)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        comment.status
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "text-dark-gray mb-0 text-uppercase small date comment-status",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(comment.status) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "my-auto",
                        attrs: {
                          cols: "9",
                          sm: "8",
                          md: "7",
                          offset: "3",
                          "offset-sm": "0",
                        },
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "text-left text-light-gray mb-0" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(comment.comment) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("add-document-comment", {
        attrs: { placeholder: _vm.commentPlaceholder },
        on: { submit: _vm.handleCommentSubmit },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }